<script>
import Layout from "../../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../../app.config";

import agentNumbers from "../../widgets/agentNumbers.vue";
import clientsNumbers from "../../widgets/clientsNumbers";
import prospectNumbers from "../../widgets/prospectNumbers";
import jwt_decode from "jwt-decode";
import axios from "axios";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Swal from "sweetalert2";
import moment from "moment";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.scss";
import { SimpleBar } from "simplebar-vue3";
import SkeletonCard from "@/components/widgets/SkeletonCard.vue";
import SkeletonStats from "@/components/widgets/SkeletonStats.vue";
import EmptyState from "@/components/widgets/EmptyState.vue";
import "@/assets/css/animations.css";

export default {
  page: {
    title: "CRM",
    meta: [{name: "description", content: appConfig.description}],
  },
  data() {
    return {
      title: "CRM",
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "CRM",
          active: true,
        },
      ],
      agentsList: [],
      stateSelected: "ALL",
      clientsList: [],
      prospectsList: [],
      data: {
        token: localStorage.getItem('jwt'),
        searchValues: {
          state: 'ALL',
        }
      },
      date: null,
      userFullName: localStorage.getItem('firstName') + ' ' + localStorage.getItem('lastname'),
      value1: 1,
      firstnameInput: '',
      lastnameInput: '',
      phonenumberInput: '',
      dateOfBirth: '',
      Address: '',
      timeGroup: '',
      language: '',
      state: '',
      cityInput: '',
      postalCode: '',
      agentNumber: '',
      licenseNumber: '',
      timeConfig: {
        enableTime: false,
        dateFormat: "d M, Y"
      },
      completeForm: localStorage.getItem('completeForm'),
      statesList: {},
      calendarEvents: [],
      recentActivity: [],
      selectedActivity: null,
      showActivityModal: false,
      loadingAgents: false,
      loadingClients: false,
      loadingProspects: false,
      loadingEvents: false,
      loadingActivity: false,
    };
  },
  components: {
    Layout,
    PageHeader,
    agentNumbers,
    clientsNumbers,
    prospectNumbers,
    flatPickr,
    Multiselect,
    SimpleBar,
    SkeletonCard,
    SkeletonStats,
    EmptyState
  },
  methods: {
    async getCalendarEvents() {
      this.loadingEvents = true;
      var date = new Date();
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

      const data = {
        token: localStorage.getItem('jwt'),
        userEmail: localStorage.getItem('email'),
        userID: localStorage.getItem('id'),
        from: firstDay.toISOString(),
        to: lastDay.toISOString(),
      };

      await axios.post('/api/getCalendarEvents', data).then((response) => {
        this.calendarEvents = response.data;
      }).catch((error) => {
        console.log(error);
      }).finally(() => {
        this.loadingEvents = false;
      });
    },
    connectGoogleCalendar() {
      const userID = localStorage.getItem("id");
      const token = localStorage.getItem("jwt");

      // Opens OAuth start
      const url = `https://a3j63o3n9.dmbgroup.online/api/gcal/oauth/start?userID=${encodeURIComponent(userID)}&token=${encodeURIComponent(token)}`;
      const w = window.open(url, "gcal_oauth", "width=520,height=700");

      // When window closes, try to refresh events
      const timer = setInterval(() => {
        if (!w || w.closed) {
          clearInterval(timer);
          this.getCalendarEvents();
        }
      }, 700);
    },
    async getRecentActivity() {
      this.loadingActivity = true;
      const data = {
        token: localStorage.getItem('jwt'),
      };
      await axios.post('/api/getRecentActivity', data).then((response) => {
         this.recentActivity = response.data;
      }).catch((err) => {
         console.error("Error fetching activity:", err);
      }).finally(() => {
        this.loadingActivity = false;
      });
    },
    openActivityModal(activity) {
      this.selectedActivity = activity;
      this.showActivityModal = true;
    },
    closeActivityModal() {
      this.showActivityModal = false;
      this.selectedActivity = null;
    },
    formatDate: function (date, format) {
      date = moment(date).format(format);
      return date;
    },
    parseChange(value) {
        try {
            let parsed = value;
            if (typeof value === 'string' && (value.startsWith('{') || value.startsWith('['))) {
                parsed = JSON.parse(value);
            }
            if (parsed && typeof parsed === 'object' && 'new' in parsed && 'old' in parsed) {
                return { 
                    isFormatted: true, 
                    old: parsed.old !== null && parsed.old !== undefined ? parsed.old : 'N/A', 
                    new: parsed.new !== null && parsed.new !== undefined ? parsed.new : 'N/A' 
                };
            }
            return { isFormatted: false, value: value };
        } catch (e) {
            return { isFormatted: false, value: value };
        }
    },
    formatKey(key) {
      const map = {
        'isLicensed': 'Is Licensed',
        'departmentID': 'Department',
        'lastName': 'Last Name',
        'firstName': 'First Name',
        'postalCode': 'Zip Code',
        'agentNumber': 'Agent Number',
        'dateOfBirth': 'Date Of Birth',
        'phoneNumber': 'Phone Number',
        'interviewDate': 'Interview Date',
        'licenseNumber': 'License Number',
        'username': null, // Hide this
      };
      
      if (Object.prototype.hasOwnProperty.call(map, key)) {
         return map[key];
      }
      return key.replace(/_/g, ' '); // Default fallback
    },
    formatValue(key, value) {
      // Handle Language
      if (key === 'language' || key === 'Language') {
         if (String(value) === '1') return 'Spanish';
         if (String(value) === '2') return 'English';
      }
      
      // Handle isLicensed
      if (key === 'isLicensed' || key === 'Is Licensed') {
         if (String(value) === '1' || String(value).toLowerCase() === 'yes') return 'Yes';
         if (String(value) === '0' || String(value).toLowerCase() === 'no') return 'No';
      }

      // Handle Department (Optional: if we had a map of IDs to names, we'd do it here. 
      // For now, user didn't explicitly ask to map Department IDs, but the screenshot showed names.
      // If the backend sends names, great. If IDs, we might need a map. 
      // Assuming backend sends names based on screenshot showing "Gabriela Prado").

      // Handle Dates
      if (key === 'interviewDate' || key === 'dateOfBirth' || key === 'Interview Date' || key === 'Date Of Birth') {
          if (value && value !== 'N/D' && value !== 'N/A' && moment(value).isValid()) {
              return moment(value).format('MMMM DD, YYYY hh:mm A');
          }
      }
      
      return value;
    },
    viewPermission(request) {
      const currentRole = jwt_decode(localStorage.getItem('jwt'))
      return currentRole.vueViews.includes(request)
    },
    validPhone: function (phone) {
      return /^(\+{0,})(\d{0,})([(]{1}\d{1,3}[)]{0,}){0,}(\s?\d+|\+\d{2,3}\s{1}\d+|\d+){1}[\s|-]?\d+([\s|-]?\d+){1,2}(\s){0,}$/gm.test(phone);
    },
    async updateProfile() {

      this.errors = []
      if (!this.firstnameInput) {
        this.errors.push('First Name is required.');
      }

      if (!this.lastnameInput) {
        this.errors.push('Last Name is required.');
      }

      if (!this.language) {
        this.errors.push('Language is required.');
      }

      if (!this.phonenumberInput) {
        this.errors.push('Phone is required.');
      }

      if (this.validPhone(this.phonenumberInput) === false &&
          this.phonenumberInput !== '') {
        this.errors.push('Please, write a valid phone number!');
      }

      if (!this.dateOfBirth) {
        this.errors.push('Birth date is required.');
      }

      if (!this.Address) {
        this.errors.push('Address is required.');
      }

      if (!this.agentNumber) {
        this.errors.push('Agent Number is required.');
      }

      if (!this.errors.length) {
        const data = {
          username: '',
          firstName: this.firstnameInput,
          lastName: this.lastnameInput,
          language: this.language,
          phoneNumber: this.phonenumberInput,
          state: this.state,
          city: this.cityInput,
          birthDate: (this.dateOfBirth.length > 8 ? this.formatDate(this.dateOfBirth, 'DD MMM, YYYY') : this.dateOfBirth),
          address: this.Address,
          postalCode: this.postalCode,
          agentNumber: this.agentNumber,
          licenseNumber: this.licenseNumber,
          isLicensed: this.value1,
          timeGroup: this.timeGroup,
          token: localStorage.getItem('jwt'),
          userID: localStorage.getItem('id'),
        }

        await axios
            .put('/api/updateUserProfile', data)
            .then(async response => {
              if (response.status === 200) {
                await Swal.fire({
                  icon: 'success',
                  title: 'Success',
                  text: 'Profile updated!'
                });
              }

              localStorage.setItem('completeForm', 'false');
              document.getElementById("btn-close").click();
            })
            .catch(async error => {
              if (error.response) {

                if (error.response.data.detail === 'Your session is expired!') {
                  this.$router.push('logout')
                }

                let list = '';
                for (const property in error.response.data) {
                  this.errors.push(`${property}: ${error.response.data[property]}`)
                  list += '\n' + '<b>' + error.response.data[property] + '</b>';
                }

                await Swal.fire({
                  title: "Please check the following: " + list,
                  icon: 'warning',
                  confirmButtonClass: "btn btn-info",
                  buttonsStyling: false,
                  showCloseButton: true,
                });

              } else if (error.message) {
                this.errors.push('Something was wrong, please contact your SysAdmin.')
              }
            })
      } else {
        let list = '';
        for (let i = 0; i < this.errors.length; i++)
          list += '\n' + '<b>' + this.errors[i] + '</b>';

        await Swal.fire({
          title: "Please complete the form! " + list,
          icon: 'warning',
          confirmButtonClass: "btn btn-info",
          buttonsStyling: false,
          showCloseButton: true,
        });
      }
    },
    closeUpdateModal() {
      const modal = document.querySelector('#completeInfoForm');
      const backStage = document.querySelector('#backStage');
      modal.style.display = 'none';
      backStage.style.display = 'none';
    },
    async getUser() {
      await axios
          .get('/api/user', {params: {token: localStorage.getItem('jwt')}})
          .then(response => {
            this.firstnameInput = response.data.firstName;
            this.lastnameInput = response.data.lastName;
            this.phonenumberInput = response.data.phoneNumber;
            this.dateOfBirth = (response.data.dateOfBirth.length > 8 ? this.formatDate(response.data.dateOfBirth, 'DD MMM, YYYY') : response.data.dateOfBirth);
            this.Address = response.data.address;
            this.timeGroup = response.data.timeGroup;
            this.language = response.data.language;
            this.state = response.data.state;
            this.cityInput = response.data.city;
            this.postalCode = response.data.postalCode;
            this.agentNumber = response.data.agentNumber;
            this.licenseNumber = response.data.licenseNumber;
            this.value1 = response.data.isLicensed;
            if (response.data.callupUsername !== undefined) {
              localStorage.setItem('callupUsername', response.data.callupUsername || '');
            }
          })
          .catch(error => {
            if (error.response) {
              for (const property in error.response.data) {
                this.errors.push(`${property}: ${error.response.data[property]}`)
              }
            } else if (error.message) {
              this.errors.push('Something was wrong, please contact your SysAdmin.')
            }
          })
    },
    async updateAgentList() {
      const data = {
        token: localStorage.getItem('jwt'),
        searchValues: this.data.searchValues,
        stateSelected: this.stateSelected
      }

      if (this.viewUserGroup('SUPER_ADMIN_GROUP') || this.viewUserGroup('ADMIN_GROUP')) {
        // No hace nada si no tiene permisos
        return;
      }

      await axios
          .post('/api/agentsWidgetNumbers', data)
          .then(response => {
            this.agentsList = response.data
          })
          .catch(error => {
            if (error.response) {

              if (error.response.data.detail === 'Your session is expired!') {
                this.$router.push('logout')
              }
            } else if (error.message) {
              this.errors.push('Something was wrong, please contact your SysAdmin.')
            }
          })
    },
    viewUserGroup(request) {
      const currentRole = jwt_decode(localStorage.getItem('jwt'))
      return currentRole.userGroup.includes(request)
    },
  },
  async mounted() {
    this.errors = []
    const data = {
      token: localStorage.getItem('jwt'),
      searchValues: this.data.searchValues,
      stateSelected: this.stateSelected,
      isActiveState: 1,
      userID: localStorage.getItem('id')
    }

    await axios
        .post('/api/listStates', data)
        .then(response => {
          this.statesList = response.data
        })
        .catch(error => {
          if (error.response) {

            if (error.response.data.detail === 'Your session is expired!') {
              this.$router.push('logout')
            }

            Swal.fire("Oops!", "Status could not be loaded, please contact your SysAdmin.", "error")
          }
        })

    if (this.viewUserGroup('SUPER_ADMIN_GROUP') || this.viewUserGroup('ADMIN_GROUP')){
      this.loadingAgents = true;
      await axios
          .post('/api/agentsWidgetNumbers', data)
          .then(response => {
            this.agentsList = response.data
            this.clientsList = response.data
          })
          .catch(error => {
            if (error.response) {

              if (error.response.data.detail === 'Your session is expired!') {
                this.$router.push('logout')
              }
              // for (const property in error.response.data) {
              // this.errors.push(`${property}: ${error.response.data[property]}`)
              // }
            } else if (error.message) {
              this.errors.push('Something was wrong, please contact your SysAdmin.')
            }
          })
          .finally(() => {
            this.loadingAgents = false;
          })
    }

    this.loadingClients = true;
    this.loadingProspects = true;
    await axios
        .post('/api/client/clientsWidgetNumbers', data)
        .then(response => {
          this.clientsList = response.data.client
          this.prospectsList = response.data.prospect
        })
        .catch(error => {
          if (error.response) {

            if (error.response.data.detail === 'Your session is expired!') {
              this.$router.push('logout')
            }
          } else if (error.message) {
            this.errors.push('Something was wrong, please contact your SysAdmin.')
          }
        })
        .finally(() => {
          this.loadingClients = false;
          this.loadingProspects = false;
        })
    this.getCalendarEvents(); // Fetch events
    this.getRecentActivity();


    await axios
        .post('/api/getBootcamp', data)
        .catch(error => {
          if (error.response) {

            if (error.response.data.detail === 'Your session is expired!') {
              this.$router.push('logout')
            }
            // for (const property in error.response.data) {
            // this.errors.push(`${property}: ${error.response.data[property]}`)
            // }
          } else if (error.message) {
            this.errors.push('Something was wrong, please contact your SysAdmin.')
          }
        })

    if (this.completeForm === 'true') {
      await this.getUser()
    }
  },
  computed: {}
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>

    <div class="card" v-if="viewUserGroup('SUPER_ADMIN_GROUP') || viewUserGroup('ADMIN_GROUP')">
      <div class="card-body">
        <div class="row g-3">
          <div class="col-xxl-4 col-sm-4" style="margin-bottom: 5px;">
            <div class="d-flex align-items-center gap-2">
              <span class="text-muted flex-shrink-0">States Filter: </span>

              <Multiselect class="form-control"
                           style="padding: 0px;"
                           v-model="this.stateSelected"
                           autocomplete="off"
                           :close-on-select="true"
                           :searchable="true"
                           :options="this.statesList"
                           @select="updateAgentList()"
              />

            </div>
          </div>
        </div><!--end row-->
      </div>
    </div><!--end card-->

    <div class="row" v-if="viewPermission('AGENTLIST')">
      <div class="col-xl-12">
        <SkeletonStats v-if="loadingAgents" :count="5" />
        <agentNumbers v-else :agentsList="agentsList" :stateSelected="stateSelected" class="fade-in"/>
      </div>
    </div>
    <!-- end widget agents -->

    <div class="row">
      <div class="col-xl-6" v-if="viewPermission('CLIENTLIST')">
        <SkeletonStats v-if="loadingClients" :count="3" />
        <clientsNumbers v-else :clientsList="clientsList" class="fade-in"/>
      </div>
      <div class="col-xl-6" v-if="viewPermission('PROSPECTLIST')">
        <SkeletonStats v-if="loadingProspects" :count="3" />
        <prospectNumbers v-else :prospectsList="prospectsList" class="fade-in"/>
      </div>
    </div>
    <!-- end widget clients/ prospects -->

    <div class="row">
      <div class="col-xxl-5">
        <div class="card card-height-100">
          <div class="card-header align-items-center d-flex">
            <h4 class="card-title mb-0 flex-grow-1">Upcoming Events</h4>
            <div class="flex-shrink-0">
              <div class="dropdown card-header-dropdown">
                <a class="text-reset dropdown-btn" href="#" data-bs-toggle="dropdown" aria-haspopup="true"
                   aria-expanded="false">
                  <span class="text-muted fs-18"><i class="mdi mdi-dots-vertical"></i></span>
                </a>
                <div class="dropdown-menu dropdown-menu-end">
                  <a class="dropdown-item" href="#">Edit</a>
                  <a class="dropdown-item" href="#">Remove</a>
                </div>
              </div>
            </div>
          </div>
          <!-- end card header -->
          <div class="card-body pt-0">
            <SimpleBar style="max-height: 365px" class="p-3">
              <!-- Loading State -->
              <SkeletonCard v-if="loadingEvents" variant="calendar" :rows="4" />
              
              <!-- Events List -->
              <ul v-else-if="calendarEvents.length" class="list-group list-group-flush border-dashed">
                <li class="list-group-item ps-0 stagger-item" v-for="event in calendarEvents" :key="event.id">
                  <div class="row align-items-center g-3">
                    <div class="col-auto">
                      <div class="avatar-sm p-1 py-2 h-auto bg-light rounded-3">
                        <div class="text-center">
                          <h5 class="mb-0">{{ formatDate(event.start, 'DD')}}</h5>
                          <div class="text-muted">{{ formatDate(event.start, 'ddd') }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="col">
                      <h5 class="text-muted mt-0 mb-1 fs-13">
                        {{ formatDate(event.start, 'hh:mm A') }} - {{ formatDate(event.end, 'hh:mm A') }}
                      </h5>
                      <a href="#" class="text-reset fs-14 mb-0">{{ event.title }}</a>
                    </div>
                    <div class="col-sm-auto">
                      <div class="avatar-group">
                        <div class="avatar-group-item">
                          <div class="avatar-xs">
                              <div :class="`avatar-title rounded-circle ${(event.classNames && event.classNames.length) ? event.classNames[0] : 'bg-primary'}`"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
              
              <!-- Enhanced Empty State -->
              <EmptyState 
                v-else
                icon="ri-calendar-line"
                iconBgClass="bg-soft-info text-info"
                title="No upcoming events"
                description="Connect your Google Calendar to see your upcoming events and appointments."
                actionText="Connect Google Calendar"
                actionIcon="mdi mdi-google"
                actionClass="btn-primary btn-sm"
                @action="connectGoogleCalendar"
              />
            </SimpleBar>

<!--            <ul class="list-group list-group-flush border-dashed">-->
<!--              <li class="list-group-item ps-0">-->
<!--                <div class="row align-items-center g-3">-->
<!--                  <div class="col-auto">-->
            <!--                    <div class="avatar-sm p-1 py-2 h-auto bg-light rounded-3">-->
            <!--                      <div class="text-center">-->
            <!--                        <h5 class="mb-0">25</h5>-->
            <!--                        <div class="text-muted">Tue</div>-->
            <!--                      </div>-->
            <!--                    </div>-->
            <!--                  </div>-->
            <!--                  <div class="col">-->
            <!--                    <h5 class="text-muted mt-0 mb-1 fs-13">-->
            <!--                      12:00am - 03:30pm-->
            <!--                    </h5>-->
            <!--                    <a href="#" class="text-reset fs-14 mb-0">Meeting for campaign with sales team</a>-->
            <!--                  </div>-->
            <!--                  <div class="col-sm-auto">-->
            <!--                    <div class="avatar-group">-->
            <!--                      <div class="avatar-group-item">-->
            <!--                        <a href="javascript: void(0);" class="d-inline-block" data-bs-toggle="tooltip"-->
            <!--                           data-bs-placement="top" title="" data-bs-original-title="Stine Nielsen">-->
            <!--                          <img src="@/assets/images/users/avatar-1.jpg" alt="" class="rounded-circle avatar-xxs" />-->
            <!--                        </a>-->
            <!--                      </div>-->
            <!--                      <div class="avatar-group-item">-->
            <!--                        <a href="javascript: void(0);" class="d-inline-block" data-bs-toggle="tooltip"-->
            <!--                           data-bs-placement="top" title="" data-bs-original-title="Jansh Brown">-->
            <!--                          <img src="@/assets/images/users/avatar-2.jpg" alt="" class="rounded-circle avatar-xxs" />-->
            <!--                        </a>-->
            <!--                      </div>-->
            <!--                      <div class="avatar-group-item">-->
            <!--                        <a href="javascript: void(0);" class="d-inline-block" data-bs-toggle="tooltip"-->
            <!--                           data-bs-placement="top" title="" data-bs-original-title="Dan Gibson">-->
            <!--                          <img src="@/assets/images/users/avatar-3.jpg" alt="" class="rounded-circle avatar-xxs" />-->
            <!--                        </a>-->
            <!--                      </div>-->
            <!--                      <div class="avatar-group-item">-->
            <!--                        <a href="javascript: void(0);">-->
            <!--                          <div class="avatar-xxs">-->
            <!--                            <span class="-->
            <!--                                avatar-title-->
            <!--                                rounded-circle-->
            <!--                                bg-info-->
            <!--                                text-white-->
            <!--                              ">-->
            <!--                              5-->
            <!--                            </span>-->
            <!--                          </div>-->
            <!--                        </a>-->
            <!--                      </div>-->
            <!--                    </div>-->
            <!--                  </div>-->
            <!--                </div>-->
            <!--                &lt;!&ndash; end row &ndash;&gt;-->
            <!--              </li>-->
            <!--              &lt;!&ndash; end &ndash;&gt;-->
            <!--              <li class="list-group-item ps-0">-->
            <!--                <div class="row align-items-center g-3">-->
            <!--                  <div class="col-auto">-->
            <!--                    <div class="avatar-sm p-1 py-2 h-auto bg-light rounded-3">-->
            <!--                      <div class="text-center">-->
            <!--                        <h5 class="mb-0">20</h5>-->
            <!--                        <div class="text-muted">Wed</div>-->
            <!--                      </div>-->
            <!--                    </div>-->
            <!--                  </div>-->
            <!--                  <div class="col">-->
            <!--                    <h5 class="text-muted mt-0 mb-1 fs-13">-->
            <!--                      02:00pm - 03:45pm-->
            <!--                    </h5>-->
            <!--                    <a href="#" class="text-reset fs-14 mb-0">Adding a new event with attachments</a>-->
            <!--                  </div>-->
            <!--                  <div class="col-sm-auto">-->
            <!--                    <div class="avatar-group">-->
            <!--                      <div class="avatar-group-item">-->
            <!--                        <a href="javascript: void(0);" class="d-inline-block" data-bs-toggle="tooltip"-->
            <!--                           data-bs-placement="top" title="" data-bs-original-title="Frida Bang">-->
            <!--                          <img src="@/assets/images/users/avatar-4.jpg" alt="" class="rounded-circle avatar-xxs" />-->
            <!--                        </a>-->
            <!--                      </div>-->
            <!--                      <div class="avatar-group-item">-->
            <!--                        <a href="javascript: void(0);" class="d-inline-block" data-bs-toggle="tooltip"-->
            <!--                           data-bs-placement="top" title="" data-bs-original-title="Malou Silva">-->
            <!--                          <img src="@/assets/images/users/avatar-5.jpg" alt="" class="rounded-circle avatar-xxs" />-->
            <!--                        </a>-->
            <!--                      </div>-->
            <!--                      <div class="avatar-group-item">-->
            <!--                        <a href="javascript: void(0);" class="d-inline-block" data-bs-toggle="tooltip"-->
            <!--                           data-bs-placement="top" title="" data-bs-original-title="Simon Schmidt">-->
            <!--                          <img src="@/assets/images/users/avatar-6.jpg" alt="" class="rounded-circle avatar-xxs" />-->
            <!--                        </a>-->
            <!--                      </div>-->
            <!--                      <div class="avatar-group-item">-->
            <!--                        <a href="javascript: void(0);" class="d-inline-block" data-bs-toggle="tooltip"-->
            <!--                           data-bs-placement="top" title="" data-bs-original-title="Tosh Jessen">-->
            <!--                          <img src="@/assets/images/users/avatar-7.jpg" alt="" class="rounded-circle avatar-xxs" />-->
            <!--                        </a>-->
            <!--                      </div>-->
            <!--                      <div class="avatar-group-item">-->
            <!--                        <a href="javascript: void(0);">-->
            <!--                          <div class="avatar-xxs">-->
            <!--                            <span class="-->
            <!--                                avatar-title-->
            <!--                                rounded-circle-->
            <!--                                bg-success-->
            <!--                                text-white-->
            <!--                              ">-->
            <!--                              3-->
            <!--                            </span>-->
            <!--                          </div>-->
            <!--                        </a>-->
            <!--                      </div>-->
            <!--                    </div>-->
            <!--                  </div>-->
            <!--                </div>-->
            <!--                &lt;!&ndash; end row &ndash;&gt;-->
            <!--              </li>-->
            <!--              &lt;!&ndash; end &ndash;&gt;-->
            <!--              <li class="list-group-item ps-0">-->
            <!--                <div class="row align-items-center g-3">-->
            <!--                  <div class="col-auto">-->
            <!--                    <div class="avatar-sm p-1 py-2 h-auto bg-light rounded-3">-->
            <!--                      <div class="text-center">-->
            <!--                        <h5 class="mb-0">17</h5>-->
            <!--                        <div class="text-muted">Wed</div>-->
            <!--                      </div>-->
            <!--                    </div>-->
            <!--                  </div>-->
            <!--                  <div class="col">-->
            <!--                    <h5 class="text-muted mt-0 mb-1 fs-13">-->
            <!--                      04:30pm - 07:15pm-->
            <!--                    </h5>-->
            <!--                    <a href="#" class="text-reset fs-14 mb-0">Create new project Bundling Product</a>-->
            <!--                  </div>-->
            <!--                  <div class="col-sm-auto">-->
            <!--                    <div class="avatar-group">-->
            <!--                      <div class="avatar-group-item">-->
            <!--                        <a href="javascript: void(0);" class="d-inline-block" data-bs-toggle="tooltip"-->
            <!--                           data-bs-placement="top" title="" data-bs-original-title="Nina Schmidt">-->
            <!--                          <img src="@/assets/images/users/avatar-8.jpg" alt="" class="rounded-circle avatar-xxs" />-->
            <!--                        </a>-->
            <!--                      </div>-->
            <!--                      <div class="avatar-group-item">-->
            <!--                        <a href="javascript: void(0);" class="d-inline-block" data-bs-toggle="tooltip"-->
            <!--                           data-bs-placement="top" title="" data-bs-original-title="Stine Nielsen">-->
            <!--                          <img src="@/assets/images/users/avatar-1.jpg" alt="" class="rounded-circle avatar-xxs" />-->
            <!--                        </a>-->
            <!--                      </div>-->
            <!--                      <div class="avatar-group-item">-->
            <!--                        <a href="javascript: void(0);" class="d-inline-block" data-bs-toggle="tooltip"-->
            <!--                           data-bs-placement="top" title="" data-bs-original-title="Jansh Brown">-->
            <!--                          <img src="@/assets/images/users/avatar-2.jpg" alt="" class="rounded-circle avatar-xxs" />-->
            <!--                        </a>-->
            <!--                      </div>-->
            <!--                      <div class="avatar-group-item">-->
            <!--                        <a href="javascript: void(0);">-->
            <!--                          <div class="avatar-xxs">-->
            <!--                            <span class="-->
            <!--                                avatar-title-->
            <!--                                rounded-circle-->
            <!--                                bg-primary-->
            <!--                                text-white-->
            <!--                              ">-->
            <!--                              4-->
            <!--                            </span>-->
            <!--                          </div>-->
            <!--                        </a>-->
            <!--                      </div>-->
            <!--                    </div>-->
            <!--                  </div>-->
            <!--                </div>-->
            <!--                &lt;!&ndash; end row &ndash;&gt;-->
            <!--              </li>-->
            <!--              &lt;!&ndash; end &ndash;&gt;-->
            <!--              <li class="list-group-item ps-0">-->
            <!--                <div class="row align-items-center g-3">-->
            <!--                  <div class="col-auto">-->
            <!--                    <div class="avatar-sm p-1 py-2 h-auto bg-light rounded-3">-->
            <!--                      <div class="text-center">-->
            <!--                        <h5 class="mb-0">12</h5>-->
            <!--                        <div class="text-muted">Tue</div>-->
            <!--                      </div>-->
            <!--                    </div>-->
            <!--                  </div>-->
            <!--                  <div class="col">-->
            <!--                    <h5 class="text-muted mt-0 mb-1 fs-13">-->
            <!--                      10:30am - 01:15pm-->
            <!--                    </h5>-->
            <!--                    <a href="#" class="text-reset fs-14 mb-0">Weekly closed sales won checking with sales team</a>-->
            <!--                  </div>-->
            <!--                  <div class="col-sm-auto">-->
            <!--                    <div class="avatar-group">-->
            <!--                      <div class="avatar-group-item">-->
            <!--                        <a href="javascript: void(0);" class="d-inline-block" data-bs-toggle="tooltip"-->
            <!--                           data-bs-placement="top" title="" data-bs-original-title="Stine Nielsen">-->
            <!--                          <img src="@/assets/images/users/avatar-1.jpg" alt="" class="rounded-circle avatar-xxs" />-->
            <!--                        </a>-->
            <!--                      </div>-->
            <!--                      <div class="avatar-group-item">-->
            <!--                        <a href="javascript: void(0);" class="d-inline-block" data-bs-toggle="tooltip"-->
            <!--                           data-bs-placement="top" title="" data-bs-original-title="Jansh Brown">-->
            <!--                          <img src="@/assets/images/users/avatar-5.jpg" alt="" class="rounded-circle avatar-xxs" />-->
            <!--                        </a>-->
            <!--                      </div>-->
            <!--                      <div class="avatar-group-item">-->
            <!--                        <a href="javascript: void(0);" class="d-inline-block" data-bs-toggle="tooltip"-->
            <!--                           data-bs-placement="top" title="" data-bs-original-title="Dan Gibson">-->
            <!--                          <img src="@/assets/images/users/avatar-2.jpg" alt="" class="rounded-circle avatar-xxs" />-->
            <!--                        </a>-->
            <!--                      </div>-->
            <!--                      <div class="avatar-group-item">-->
            <!--                        <a href="javascript: void(0);">-->
            <!--                          <div class="avatar-xxs">-->
            <!--                            <span class="-->
            <!--                                avatar-title-->
            <!--                                rounded-circle-->
            <!--                                bg-warning-->
            <!--                                text-white-->
            <!--                              ">-->
            <!--                              9-->
            <!--                            </span>-->
            <!--                          </div>-->
            <!--                        </a>-->
            <!--                      </div>-->
            <!--                    </div>-->
            <!--                  </div>-->
            <!--                </div>-->
            <!--                &lt;!&ndash; end row &ndash;&gt;-->
            <!--              </li>-->
            <!--              &lt;!&ndash; end &ndash;&gt;-->
            <!--            </ul>-->
            <!-- end -->
            <!--            <div class="align-items-center mt-2 row text-center text-sm-start">-->
            <!--              <div class="col-sm">-->
            <!--                <div class="text-muted">-->
            <!--                  Showing<span class="fw-semibold">4</span> of-->
            <!--                  <span class="fw-semibold">125</span> Results-->
            <!--                </div>-->
            <!--              </div>-->
            <!--              <div class="col-sm-auto">-->
            <!--                <ul class="-->
            <!--                    pagination pagination-separated pagination-sm-->
            <!--                    justify-content-center justify-content-sm-start-->
            <!--                    mb-0-->
            <!--                  ">-->
            <!--                  <li class="page-item disabled">-->
            <!--                    <a href="#" class="page-link">←</a>-->
            <!--                  </li>-->
            <!--                  <li class="page-item">-->
            <!--                    <a href="#" class="page-link">1</a>-->
            <!--                  </li>-->
            <!--                  <li class="page-item active">-->
            <!--                    <a href="#" class="page-link">2</a>-->
            <!--                  </li>-->
            <!--                  <li class="page-item">-->
            <!--                    <a href="#" class="page-link">3</a>-->
            <!--                  </li>-->
            <!--                  <li class="page-item">-->
            <!--                    <a href="#" class="page-link">→</a>-->
            <!--                  </li>-->
            <!--                </ul>-->
            <!--              </div>-->
            <!--            </div>-->
          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col-->
      <div class="col-xxl-7">
        <div class="row">
          <!-- end col -->
          <div class="col-xl-12">
            <div class="card card-height-100">
              <div class="card-header align-items-center d-flex">
                <h4 class="card-title mb-0 flex-grow-1">Recent Activity</h4>
                <div class="flex-shrink-0">
                   <button class="btn btn-soft-primary btn-sm" @click="getRecentActivity">
                      <i class="mdi mdi-refresh"></i> Refresh
                   </button>
                </div>
              </div>
              <div class="card-body p-0">
                <SimpleBar style="max-height: 365px" class="p-3">
                   <!-- Loading State -->
                   <SkeletonCard v-if="loadingActivity" variant="list" :rows="5" />
                   
                   <!-- Activity List -->
                   <ul v-else-if="recentActivity.length" class="list-group list-group-flush border-dashed">
                      <li class="list-group-item ps-0 cursor-pointer activity-item-hover stagger-item" 
                          v-for="activity in recentActivity" 
                          :key="activity.id" 
                          @click="openActivityModal(activity)">
                         <div class="d-flex align-items-start">
                            <div class="flex-shrink-0 me-3">
                               <img v-if="activity.userAvatar" :src="activity.userAvatar" class="avatar-xs rounded-circle" alt="" />
                               <div v-else class="avatar-xs">
                                  <span class="avatar-title bg-soft-primary text-primary rounded-circle fs-16">
                                     {{ activity.userName.charAt(0) }}
                                  </span>
                               </div>
                            </div>
                            <div class="flex-grow-1">
                               <h5 class="text-muted fs-13 mb-1 truncate-username">{{ activity.userName }}</h5>
                               <p class="mb-0 fs-12">{{ activity.description }}</p>
                            </div>
                            <div class="flex-shrink-0 ms-2">
                               <small class="text-muted">{{ formatDate(activity.createdOn, "MMM DD, hh:mm A") }}</small>
                            </div>
                         </div>
                      </li>
                   </ul>
                   
                   <!-- Enhanced Empty State -->
                   <EmptyState 
                     v-else
                     icon="ri-history-line"
                     iconBgClass="bg-soft-light text-muted"
                     title="No recent activity"
                     description="Activity from your team will appear here. Check back soon!"
                   />
                </SimpleBar>
              </div>
            </div>
            <!-- end card -->
          </div>
          <!-- end col -->
        </div>
        <!-- end row-->
      </div>
      <!-- end col-xl-7-->
    </div>
    <!-- end row-->

    <div id="completeInfoForm" class="modal fade show" tabindex="-1" aria-labelledby="myModalLabel" aria-hidden="true"
         style="display: block;" v-if="completeForm === 'true'" aria-modal="true" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content ">
          <div class="modal-header">
            <h5 class="modal-title" id="completeInfoForm">Update Profile</h5>
            <button type="button" id="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    @click="closeUpdateModal"></button>
          </div>
          <div class="modal-body">
            <form action="javascript:void(0);">
              <div class="row">
                <div class="col-lg-6">
                  <div class="mb-3">
                    <label for="firstnameInput" class="form-label"
                    >First Name</label
                    >
                    <input
                        type="text"
                        class="form-control"
                        id="firstnameInput"
                        placeholder="Enter your firstname"
                        v-model="firstnameInput"
                    />
                  </div>
                </div>
                <!--end col-->
                <div class="col-lg-6">
                  <div class="mb-3">
                    <label for="lastnameInput" class="form-label"
                    >Last Name</label>
                    <input
                        type="text"
                        class="form-control"
                        id="lastnameInput"
                        placeholder="Enter your lastname"
                        v-model="lastnameInput"
                    />
                  </div>
                </div>
                <!--end col-->
                <div class="col-lg-6">
                  <div class="mb-3">
                    <label for="phonenumberInput" class="form-label"
                    >Phone Number</label>
                    <input type="text" v-maska="['+1 (###) ##-##-##', '+1 (###) ###-##-##']"
                           class="form-control"
                           id="phonenumberInput"
                           v-model="phonenumberInput">
                    <div class="text-muted">+1 (###) ###-####</div>
                  </div>
                </div>
                <!--end col-->
                <div class="col-lg-6">
                  <div class="mb-3">
                    <label for="dateOfBirth" class="form-label"
                    >Birthdate</label>
                    <flat-pickr
                        v-model="dateOfBirth"
                        class="form-control"
                        :config="timeConfig"
                    ></flat-pickr>
                  </div>
                </div>
                <!--end col-->
                <div class="col-lg-12">
                  <div class="mb-3">
                    <label for="Address" class="form-label"
                    >Address</label
                    >
                    <input
                        type="text"
                        class="form-control"
                        id="Address"
                        placeholder="Enter your Address"
                        v-model="Address"
                    />
                  </div>
                </div>
                <!--end col-->
                <div class="col-lg-6">
                  <div class="mb-3">
                    <label for="timeGroup" class="form-label"
                    >Time Group</label
                    >
                    <input
                        type="text"
                        class="form-control"
                        id="timeGroup"
                        v-model="timeGroup"
                    />
                  </div>
                </div>
                <!--end col-->
                <div class="col-lg-6">
                  <div class="mb-3">
                    <label for="editLanguage" class="form-label">Language</label>
                    <select class="form-select mb-2" aria-label="Language" id="editLanguage" v-model="language"
                            required>
                      <option value="1" selected>English</option>
                      <option value="2">Spanish</option>
                    </select>
                  </div>
                </div>
                <!--end col-->
                <div class="col-lg-4">
                  <div class="mb-3">
                    <label for="cityInput" class="form-label">City</label>
                    <input
                        type="text"
                        class="form-control"
                        id="cityInput"
                        placeholder="City"
                        v-model="cityInput"
                    />
                  </div>
                </div>
                <!--end col-->
                <div class="col-lg-4">
                  <div class="mb-3">
                    <label for="state" class="form-label"
                    >State</label
                    >
                    <input
                        type="text"
                        class="form-control"
                        id="state"
                        placeholder="State"
                        v-model="state"
                    />
                  </div>
                </div>
                <!--end col-->
                <div class="col-lg-4">
                  <div class="mb-3">
                    <label for="postalCode" class="form-label"
                    >Postal Code</label
                    >
                    <input
                        type="text"
                        class="form-control"
                        minlength="5"
                        maxlength="6"
                        id="postalCode"
                        placeholder="Enter Postal Code"
                        v-model="postalCode"
                    />
                  </div>
                </div>
                <!--end col-->
                <div class="col-lg-6">
                  <div class="mb-3">
                    <label for="agentNumber" class="form-label"
                    >Agent Number</label>
                    <input
                        type="text"
                        class="form-control"
                        id="agentNumber"
                        placeholder=""
                        v-model="agentNumber"
                    />
                  </div>
                </div>
                <!--end col-->
                <div class="col-lg-6">
                  <label for="editAgentNumber" class="form-label">License Number</label>
                  <input type="text" id="editLicenseNumber" class="form-control mb-2" placeholder="Enter Agent Number"
                         required v-model="licenseNumber"/>
                </div>
                <!--end col-->
              </div>
              <!--end row-->
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" id="closeMove" data-bs-dismiss="modal"
                    @click="closeUpdateModal">Close
            </button>
            <button type="button" class="btn btn-primary" @click="updateProfile">Update</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->
    <div class="modal-backdrop fade show" v-show="completeForm === 'true'" id="backStage"></div>

    <div class="modal fade show" v-if="showActivityModal" style="display: block; background: rgba(0,0,0,0.5);" tabindex="-1" role="dialog">
       <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
             <div class="modal-header">
                <h5 class="modal-title">Activity Details</h5>
                <button type="button" class="btn-close" @click="closeActivityModal" aria-label="Close"></button>
             </div>
             <div class="modal-body" v-if="selectedActivity">
                <div class="d-flex align-items-center mb-3">
                   <div class="flex-shrink-0 me-3">
                       <img v-if="selectedActivity.userAvatar" :src="selectedActivity.userAvatar" class="avatar-sm rounded-circle" alt="" />
                       <div v-else class="avatar-sm">
                          <span class="avatar-title bg-soft-primary text-primary rounded-circle fs-20">
                             {{ selectedActivity.userName.charAt(0) }}
                          </span>
                       </div>
                   </div>
                   <div>
                       <h5 class="mb-1">{{ selectedActivity.userName }}</h5>
                       <small class="text-muted">{{ formatDate(selectedActivity.createdOn, "MMMM DD, YYYY hh:mm A") }}</small>
                   </div>
                </div>
                
                <h6 class="text-muted text-uppercase fs-12 mb-2">Description</h6>
                <p class="text-muted mb-4">{{ selectedActivity.description }}</p>

                <div v-if="selectedActivity.changes && Object.keys(selectedActivity.changes).length > 0">
                   <h6 class="text-muted text-uppercase fs-12 mb-2">Changes</h6>
                   <div class="table-responsive">
                      <table class="table table-sm table-borderless">
                         <tbody>
                            <tr v-for="(value, key) in selectedActivity.changes" :key="key">
                               <td class="fw-medium text-capitalize" style="width: 30%;" v-if="formatKey(key)">
                                  {{ formatKey(key) }}
                               </td>
                               <td class="text-muted" v-if="formatKey(key)">
                                   <div v-if="parseChange(value).isFormatted">
                                       <span class="text-secondary text-decoration-line-through me-1">{{ formatValue(key, parseChange(value).old) }}</span>
                                       <i class="mdi mdi-arrow-right text-muted mx-1"></i>
                                       <span class="text-primary fw-medium">{{ formatValue(key, parseChange(value).new) }}</span>
                                   </div>
                                   <span v-else>{{ formatValue(key, value) }}</span>
                               </td>
                            </tr>
                         </tbody>
                      </table>
                   </div>
                </div>
             </div>
             <div class="modal-footer">
                <button type="button" class="btn btn-light" @click="closeActivityModal">Close</button>
             </div>
          </div>
       </div>
    </div>
  </Layout>
</template>
